import Styles from './styles.module.css';
import React, { useEffect, useState } from 'react';
import { RxCross2 } from "react-icons/rx";
import { getDocs, collection, getDoc, doc, getFirestore, orderBy, query, where } from 'firebase/firestore';
import DefaultImage from "./../../../../image/default/home.png";
import { MdMenuBook, MdStar } from "react-icons/md";
import { HiOutlineDocumentText } from "react-icons/hi";
import { HiNewspaper } from "react-icons/hi2";
import SchoolJobPostings from "./2.jobPostings/index";
import SchoolOffers from "./SchoolOffers";
import { SchoolOffer, saveSchoolOffers, schoolOffersOf } from '../../../0.functions/offers';
import { time } from 'framer-motion';
import { AiOutlineLoading3Quarters } from "react-icons/ai";

type SchoolTypeProps = {
  type: any;
  setType: React.Dispatch<React.SetStateAction<any>>;
  schoolName: string;
  schoolId: string;
  // 開いている学生の最新のデータ(学校が登録した内定の表示に使う)
  user: any;
};

const SchoolType: React.FC<SchoolTypeProps> = ({ type, setType, schoolName, schoolId, user }) => {

  const showEvaluation = schoolName === "ハリウッドワールド美容専門学校" || schoolName === "ベルエポック美容専門学校 原宿校";

  const [ loading, setLoading ] = useState<boolean>(false);

  const [ salonList, setSalonList ] = useState<any[]>([]);
  const [ photoList, setPhotoList ] = useState<string[]>([]);

  const db = getFirestore();

  const [ isJobPosting, setIsJobPosting ] = useState<string>("");
  const [ evaluationData, setEvaluationData ] = useState<any>(null);

  useEffect(() => {
    if (type.type === "post") {
      fetchPostAndSalons();
    } else if (type.type === "save") {
      fetchSaveAndSalons();
    } else if (type.type === "visit") {
      fetchVisitsAndSalons();
    } else if (type.type === "apply.志望先") {
      fetchApplyAndSalons("志望先");
    } else if (type.type === "apply.応募済み") {
      fetchApplyAndSalons("応募済み");
    } else if (type.type === "apply.内定承諾") {
      fetchApplyAndSalons("内定承諾");
    }
  }, []);

  const fetchPostAndSalons = async () => {
    setLoading(true);
    const q = query(collection(db, "posts"), where("post_uid", "==", type.uid));
    const snapshot = await getDocs(q);
    const newPhotos = snapshot.docs.map((doc) => doc.id);
    setPhotoList(newPhotos);
    setLoading(false);
  }

  const fetchSaveAndSalons = async () => {
    setLoading(true);

    const userRef = doc(db, "users", type.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
      setSalonList([]);
      setLoading(false);
      return;
    }

    const userData = userSnap.data();
    const recruitSaves: string[] =
      userData?.activity?.recruitSaves ?? [];

    if (recruitSaves.length === 0) {
      setSalonList([]);
      setLoading(false);
      return;
    }

    const salons: any[] = [];

    // for文で searchIndex を取得
    for (const recruitId of recruitSaves) {
      if (!recruitId) continue;

      const recruitRef = doc(db, "searchIndex", recruitId);
      const recruitSnap = await getDoc(recruitRef);

      if (recruitSnap.exists()) {
        salons.push({
          id: recruitSnap.id,
          ...recruitSnap.data(),
        });
      }
    }

    setSalonList(salons);
    setLoading(false);
  };

  const fetchVisitsAndSalons = async () => {
    setLoading(true);
    const pvRef = collection(db, "users", type.uid, "visits");
    const pvSnap = await getDocs(pvRef);

    if (pvSnap.empty) {
      setSalonList([]);
      setLoading(false);
      return;
    }

    const salons: any[] = [];

    for (const pvDoc of pvSnap.docs) {

      const pvData = pvDoc.data();
      const recruitId = pvData.recruitId;
      const time = pvData.schedule ?? null;
      const ev = pvData.evaluation;
      const evaluation = ev ? {
        save: ev.save === true,
        star: ev.star ?? null,
        intention: ev.intention ?? null,
        memo: ev.memo ?? null,
        schedule: pvData.schedule ?? null,
        interviewDate: ev.interviewDate ?? null,
        noticeDate: ev.noticeDate ?? null,
        resumeDeadline: ev.resumeDeadline ?? null,
        time: ev.time ?? null,
      } : null;

      if (!recruitId) continue;

      const recruitRef = doc(db, "searchIndex", recruitId);
      const recruitSnap = await getDoc(recruitRef);

      if (recruitSnap.exists()) {
        salons.push({
          id: recruitSnap.id,
          ...recruitSnap.data(),
          time,
          evaluation,
        });
      } else {
        salons.push({
          id: pvData.id,
          name: pvData.name,
          pref: pvData.pref,
          jobPostingsStatus: false,
          recruitStatus: false,
          pamphlet: false,
          time,
          evaluation,
        });
      }
    }

    setSalonList(salons);
    setLoading(false);
  };

  const fetchApplyAndSalons = async (status: string) => {

    setLoading(true);
    const pvRef = collection(db, "users", type.uid, "apply");
    const pvSnap = await getDocs(pvRef);

    if (pvSnap.empty) {
      setSalonList([]);
      setLoading(false);
      return;
    }

    const salons: any[] = [];

    for (const pvDoc of pvSnap.docs) {

      const pvData = pvDoc.data();
      const recruitId = pvData.recruitId;
      const time = pvData.schedule;

      if (pvData.status !== status) continue;

      if (!recruitId) continue;

      const recruitRef = doc(db, "searchIndex", recruitId);
      const recruitSnap = await getDoc(recruitRef);

      if (recruitSnap.exists()) {
        salons.push({
          id: recruitSnap.id,
          ...recruitSnap.data(),
          time,
        });
      } else {
        salons.push({
          id: pvData.id,
          name: pvData.name,
          pref: pvData.pref,
          jobPostingsStatus: false,
          recruitStatus: false,
          pamphlet: false,
          time,
        });
      }
    }

    setSalonList(salons);
    setLoading(false);
  };

  // 内定承諾の一覧では、学校が登録した内定も学生が登録したものと同じ形の行で並べる(「学校登録」の印と削除ボタン付き)。
  // memorii の求人と紐づいているものは、求人の情報(都道府県・求人票・パンフ・求人)も出す。
  const schoolOffers = type.type === "apply.内定承諾" ? schoolOffersOf(user, schoolId) : [];
  const schoolOffersKey = JSON.stringify(schoolOffers);
  const [ schoolOfferRows, setSchoolOfferRows ] = useState<any[]>([]);
  useEffect(() => {
    let cancelled = false;
    if (schoolOffers.length === 0) { setSchoolOfferRows([]); return; }
    Promise.all(schoolOffers.map(async (offer: SchoolOffer) => {
      const base = { schoolOffer: offer, time: null };
      if (offer.recruitId) {
        try {
          const snap = await getDoc(doc(db, "searchIndex", offer.recruitId));
          if (snap.exists()) return { ...snap.data(), id: snap.id, ...base };
        } catch (e) {
          console.warn('内定先の求人を読み込めませんでした', e);
        }
      }
      return { id: offer.id, name: offer.salonName, companyId: offer.companyId, pref: '', jobPostingsStatus: false, recruitStatus: false, pamphlet: false, ...base };
    })).then((rows) => { if (!cancelled) setSchoolOfferRows(rows); });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [schoolOffersKey]);

  async function removeSchoolOffer(offer: SchoolOffer) {
    if (!window.confirm(`${offer.salonName}の内定（学校登録）を削除しますか？`)) return;
    try {
      await saveSchoolOffers(type.uid, schoolId, schoolOffers.filter((o: SchoolOffer) => o.id !== offer.id));
    } catch (e) {
      console.error('内定を削除できませんでした', e);
      window.alert('削除できませんでした。時間をおいて、もう一度お試しください。');
    }
  }

  const listRows = type.type === "apply.内定承諾" ? [...salonList, ...schoolOfferRows] : salonList;

  const closeAndClear = () => {
    setType({ uid: "", type: "" });
  };

  const formatDate = (val: any): string => {
    if (!val) return "未設定";
    const d = typeof val.toDate === 'function' ? val.toDate() : new Date(val);
    return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日`;
  };

  return (
    <>
    <div className={Styles.modal}>
      <div className={Styles.background_black} onClick={() => closeAndClear()}></div>
        {type.type === "post" ? 
        <div className={Styles.contents_post}>
          <div className={Styles.modal_title_post} style={{ width: "90%" }}>
            <h4>作品一覧</h4>
            <RxCross2 className={Styles.modal_cross} onClick={() => setType({ uid: "",  type: "" })} />
          </div>

          {loading ? <AiOutlineLoading3Quarters className={Styles.spinner} /> : <></> }

          <div className={Styles.photos}>
            <div>
              {photoList.map((data, index) =>
                <img alt='' key={index} src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/image%2Fresize_images%2F${data}_500x500?alt=media&token=${time}`} />
              )}
            </div>
          </div>

        </div>
        :
        <div className={Styles.contents}>
          <div className={Styles.modal_title}>
            <h4>{
            type.type === "post" ? "作品" :
            type.type === "pv" ? "閲覧先" :
            type.type === "save" ? "保存先" :
            type.type === "visit" ? "サロン見学先" :
            type.type === "apply.志望先" ? "志望先" :
            type.type === "apply.応募済み" ? "応募先" :
            type.type === "apply.内定承諾" ? "内定承諾" : ""}一覧</h4>
            <RxCross2 className={Styles.modal_cross} onClick={() => setType({ uid: "",  type: "" })} />
          </div>

          <div className={Styles.graduations}>
            <div className={Styles.graduation_nav}>
              <h3 className={Styles.graduation_nav_1}>サロン名</h3>
              <h3 className={Styles.graduation_nav_2}>都道府県</h3>
              {type.type === "visit" && showEvaluation && (
                <h3 className={Styles.graduation_nav_3}>評価</h3>
              )}
              <h3 className={Styles.graduation_nav_3}>求人票</h3>
              <h3 className={Styles.graduation_nav_3}>パンフ</h3>
              <h3 className={Styles.graduation_nav_3}>求人</h3>
            </div>

            {loading ? <AiOutlineLoading3Quarters className={Styles.spinner} /> : <></> }

            {listRows.map((data) => (
            <>
              <div className={Styles.items_table}>
                <div className={Styles.items_table_box_1}>
                  <img className={Styles.items_table_box_1_img} alt=""
                    src={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/companies_logo%2Fresize_images%2F${data.companyId}_200x200?alt=media&token=?0`}
                    onError={(e) => e.currentTarget.src = DefaultImage} />
                  <div className={Styles.items_table_box_post}>
                    {/* 保存数 */}
                    {type.type === "save" && (
                    <div style={{height: "7px"}}></div> )}
                    {/* サロン見学数 */}
                    {type.type === "visit" && (
                    <div>
                      <div style={{backgroundColor: '#1B1B1B1B'}}></div>
                      <p>見学日：{data.time ? new Date(data.time).toLocaleDateString("ja-JP") : ""}</p>
                    </div> )}
                    {/* 志望先 */}
                    {(type.type  === "apply.志望先" || type.type  === "apply.応募済み" || type.type  === "apply.内定承諾") && (
                    <div>
                      <div style={{backgroundColor: '#1B1B1B1B'}}></div>
                      {data.schoolOffer
                        ? <p>
                            <span className={Styles.schoolOfferBadge}>学校登録</span>
                            {data.schoolOffer.offeredAt ? data.schoolOffer.offeredAt.replace(/-/g, '/') : ''}
                          </p>
                        : <p>変更日：{data.time?.toDate().toLocaleDateString("ja-JP")}</p>}
                    </div> )}

                    {/* メモは名前にカーソルを合わせると出す(行の高さを変えないため) */}
                    <h2 title={data.schoolOffer?.memo ? `メモ：${data.schoolOffer.memo}` : undefined}>{data.name}</h2>
                  </div>
                </div>

                <div className={Styles.items_table_box_2}>
                  <h4>
                    {(() => {
                      const prefecture = data.storeTags?.find((tag: string) =>
                        /^(北海道|東京都|大阪府|京都府|.{2,3}県)$/.test(tag)
                      );

                      return prefecture || data.pref || null;
                    })()}
                  </h4>
                </div>

                {type.type === "visit" && showEvaluation && (
                  <MdStar
                    className={Styles.icon}
                    style={
                      !data.evaluation
                        ? {color: "#EBEBEB"}
                        : data.evaluation.save === true
                          ? {color: "#F1AE54", cursor: "pointer"}
                          : {color: "#9E9E9E", cursor: "pointer"}
                    }
                    onClick={() => { if (data.evaluation) setEvaluationData(data.evaluation); }}
                  />
                )}

                <HiOutlineDocumentText className={Styles.icon} style={data.jobPostingsStatus ? {} : {color: "#EBEBEB"}}
                  onClick={() => { if (data.jobPostingsStatus) { setIsJobPosting(data.id) }}} />

                <a href={data.pamphlet ? `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/pamphlet%2F${data.id}?alt=media&token=` : undefined}
                  onClick={(e) => { if (!(data.pamphlet)) { e.preventDefault(); } }}
                  target="_blank" rel="noopener noreferrer">
                  <MdMenuBook className={Styles.icon}  style={data.pamphlet ? {} : {color: "#EBEBEB"}} />
                </a>

                <a href={data.recruitStatus || data.jobPostingsStatus ? `https://memorii-works.com/recruit/id=${data.id}` : undefined}
                  onClick={(e) => { if (!(data.recruitStatus || data.jobPostingsStatus)) { e.preventDefault(); } }}
                  target="_blank" rel="noopener noreferrer">
                  <HiNewspaper className={Styles.icon} style={data.recruitStatus || data.jobPostingsStatus ? {} : {color: "#EBEBEB"}} />
                </a>

                {data.schoolOffer && (
                  <button type="button" className={Styles.schoolOfferDelete} onClick={() => removeSchoolOffer(data.schoolOffer)}>削除</button>
                )}

              </div>
            </>))}
          </div>
          <p style={{fontSize: "10px", margin: "-10px 25px 10px"}}>※現在、非公開の求人票の情報は表示されませんので、ご了承ください。</p>

          {type.type !== "save" && (
            <p style={{fontSize: "10px", margin: "-10px 25px 10px"}}>※左側のアイコンがホームアイコンのものはサービス未利用の事業者で、学生様が直接登録している事業者です。</p>
          )}

          {/* 内定承諾の一覧では、学校が登録した内定も表示・登録できる */}
          {type.type === "apply.内定承諾" && schoolId && (
            <SchoolOffers uid={type.uid} schoolId={schoolId} user={user} />
          )}
        </div>
         }

    </div>

    {isJobPosting !== "" ?
      <SchoolJobPostings setIsJobPosting={setIsJobPosting} recruitId={isJobPosting} />
    :<></> }

    {evaluationData && showEvaluation && (
      <div className={Styles.eval_overlay}>
        <div className={Styles.background_black} onClick={() => setEvaluationData(null)}></div>
        <div className={Styles.eval_modal}>
          <div className={Styles.modal_title}>
            <h4>評価内容</h4>
            <RxCross2 className={Styles.modal_cross} onClick={() => setEvaluationData(null)} />
          </div>
          <div className={Styles.eval_content}>
            <div className={Styles.eval_row}>
              <span className={Styles.eval_label}>見学予定日</span>
              <span className={Styles.eval_value}>{formatDate(evaluationData.schedule)}</span>
            </div>
            <div className={Styles.eval_row}>
              <span className={Styles.eval_label}>評価日</span>
              <span className={Styles.eval_value}>{formatDate(evaluationData.time)}</span>
            </div>
            <div className={Styles.eval_row}>
              <span className={Styles.eval_label}>保存状態</span>
              <span className={Styles.eval_value}>{evaluationData.save === true ? "保存済み" : "一時保存"}</span>
            </div>
            <div className={Styles.eval_row}>
              <span className={Styles.eval_label}>総合評価</span>
              <span>
                {evaluationData.star
                  ? [1, 2, 3, 4, 5].map(i => (
                      <span key={i} style={{color: i <= evaluationData.star ? '#F1AE54' : '#EBEBEB', fontSize: '20px'}}>★</span>
                    ))
                  : <span className={Styles.eval_value}>未設定</span>}
              </span>
            </div>
            <div className={Styles.eval_row}>
              <span className={Styles.eval_label}>意向</span>
              <span className={Styles.eval_value}>{evaluationData.intention || "未設定"}</span>
            </div>
            <div className={Styles.eval_row}>
              <span className={Styles.eval_label}>メモ</span>
              <span className={Styles.eval_value}>{evaluationData.memo || "未設定"}</span>
            </div>
            <div className={Styles.eval_row}>
              <span className={Styles.eval_label}>書類締切</span>
              <span className={Styles.eval_value}>
                {evaluationData.resumeDeadline?.year
                  ? `${evaluationData.resumeDeadline.year}年${evaluationData.resumeDeadline.month}月${evaluationData.resumeDeadline.day}日`
                  : "未設定"}
              </span>
            </div>
            <div className={Styles.eval_row}>
              <span className={Styles.eval_label}>面接日</span>
              <span className={Styles.eval_value}>
                {evaluationData.interviewDate?.year
                  ? `${evaluationData.interviewDate.year}年${evaluationData.interviewDate.month}月${evaluationData.interviewDate.day}日`
                  : "未設定"}
              </span>
            </div>
            <div className={Styles.eval_row}>
              <span className={Styles.eval_label}>通知日</span>
              <span className={Styles.eval_value}>
                {evaluationData.noticeDate?.year
                  ? `${evaluationData.noticeDate.year}年${evaluationData.noticeDate.month}月${evaluationData.noticeDate.day}日`
                  : "未設定"}
              </span>
            </div>
          </div>
          <div className={Styles.eval_close}>
            <button onClick={() => setEvaluationData(null)}>閉じる</button>
          </div>
        </div>
      </div>
    )}
    </>
  );
}

export default SchoolType;

